import { render, staticRenderFns } from "./subject-grading.vue?vue&type=template&id=c4079d96&scoped=true"
import script from "./subject-grading.vue?vue&type=script&lang=js"
export * from "./subject-grading.vue?vue&type=script&lang=js"
import style0 from "./subject-grading.vue?vue&type=style&index=0&id=c4079d96&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4079d96",
  null
  
)

export default component.exports